<template>
  <span
    aria-hidden="true"
    class="flex flex-col items-center justify-center relative aspect-square w-10 h-10"
  >
    <FaIcon
      :name="icon"
      icon-style="light"
      :icon-size="iconSize"
      icon-class="text-red-500 relative z-10"
    />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 15"
      fill="none"
      role="img"
      class="text-gray-900 absolute top-0 right-0 w-1/3 h-1/3"
    >
      <ellipse
        cx="0.741464"
        cy="3.74967"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="0.741464"
        cy="0.416667"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="0.741464"
        cy="7.08366"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="0.741464"
        cy="10.4167"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="0.741464"
        cy="13.7497"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="3.70631"
        cy="3.74967"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="3.70631"
        cy="0.416667"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="3.70631"
        cy="7.08366"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="3.70631"
        cy="10.4167"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="3.70631"
        cy="13.7497"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="6.66725"
        cy="3.74967"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="6.66725"
        cy="0.416667"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="6.66725"
        cy="7.08366"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="6.66725"
        cy="10.4167"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="6.66725"
        cy="13.7497"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="9.63209"
        cy="3.74967"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="9.63209"
        cy="0.416667"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="9.63209"
        cy="7.08366"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="9.63209"
        cy="10.4167"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
      <ellipse
        cx="9.63209"
        cy="13.7497"
        rx="0.37037"
        ry="0.416667"
        fill="currentColor"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 11"
      fill="none"
      class="text-gray-900 absolute bottom-0 left-0  w-1/3 h-1/3"
    >
      <ellipse
        cx="9.44213"
        cy="0.582682"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 9.44213 0.582682)"
        fill="currentColor"
      />
      <ellipse
        cx="12.407"
        cy="0.582682"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 12.407 0.582682)"
        fill="currentColor"
      />
      <ellipse
        cx="6.48119"
        cy="0.582682"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 6.48119 0.582682)"
        fill="currentColor"
      />
      <ellipse
        cx="3.51635"
        cy="0.582682"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 3.51635 0.582682)"
        fill="currentColor"
      />
      <ellipse
        cx="0.555411"
        cy="0.582682"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 0.555411 0.582682)"
        fill="currentColor"
      />
      <ellipse
        cx="9.44213"
        cy="3.91569"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 9.44213 3.91569)"
        fill="currentColor"
      />
      <ellipse
        cx="12.407"
        cy="3.91569"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 12.407 3.91569)"
        fill="currentColor"
      />
      <ellipse
        cx="6.48119"
        cy="3.91569"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 6.48119 3.91569)"
        fill="currentColor"
      />
      <ellipse
        cx="3.51635"
        cy="3.91569"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 3.51635 3.91569)"
        fill="currentColor"
      />
      <ellipse
        cx="0.555411"
        cy="3.91569"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 0.555411 3.91569)"
        fill="currentColor"
      />
      <ellipse
        cx="9.44213"
        cy="7.24967"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 9.44213 7.24967)"
        fill="currentColor"
      />
      <ellipse
        cx="12.407"
        cy="7.24967"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 12.407 7.24967)"
        fill="currentColor"
      />
      <ellipse
        cx="6.48119"
        cy="7.24967"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 6.48119 7.24967)"
        fill="currentColor"
      />
      <ellipse
        cx="3.51635"
        cy="7.24967"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 3.51635 7.24967)"
        fill="currentColor"
      />
      <ellipse
        cx="0.555411"
        cy="7.24967"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 0.555411 7.24967)"
        fill="currentColor"
      />
      <ellipse
        cx="9.44213"
        cy="10.5827"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 9.44213 10.5827)"
        fill="currentColor"
      />
      <ellipse
        cx="12.407"
        cy="10.5827"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 12.407 10.5827)"
        fill="currentColor"
      />
      <ellipse
        cx="6.48119"
        cy="10.5827"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 6.48119 10.5827)"
        fill="currentColor"
      />
      <ellipse
        cx="3.51635"
        cy="10.5827"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 3.51635 10.5827)"
        fill="currentColor"
      />
      <ellipse
        cx="0.555411"
        cy="10.5827"
        rx="0.416667"
        ry="0.37037"
        transform="rotate(90 0.555411 10.5827)"
        fill="currentColor"
      />
    </svg>
  </span>
</template>

<script lang="ts" setup>
import FaIcon from '../FaIcon.vue';

interface IconOverlay {
  icon?: string;
  iconSize?: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

withDefaults(defineProps<IconOverlay>(), {
  icon: '',
  iconSize: '2xl'
});
</script>
